import { IDeliveryPoint } from '@/shared/api/postDeliveryBoxberryPoints/types';
import { wordEnding } from '@/shared/utils/wordEnding';

interface Params {
  shops: IDeliveryPoint[];
  allItems: number;
  itemsCount: number;
  onPlacemarkClick?: (item: IDeliveryPoint) => void;
}

export const initClusterer = ({ shops, allItems, itemsCount, onPlacemarkClick }: Params) => {
  const clusterer = new (window as any).ymaps.Clusterer({
    preset: 'islands#invertedVioletClusterIcons',
    groupByCoordinates: false,
    clusterDisableClickZoom: false,
    clusterHideIconOnBalloonOpen: false,
    geoObjectHideIconOnBalloonOpen: false,
    clusterIcons: [
      {
        href: '/icons/cluster.svg',
        size: [48, 48],
        offset: [-24, -24],
      },
    ],
    clusterIconContentLayout: (window as any).ymaps.templateLayoutFactory.createClass(
      '<div style="color: #213D38; font-weight: 600; font-size: 1.6rem;">$[properties.geoObjects.length]</div>'
    ),
  });

  const placemarks: any = [];

  if (shops?.length) {
    shops.forEach((item) => {
      const iconContentLayout = (window as any).ymaps.templateLayoutFactory.createClass(
        `<div class="map-marker ${item.organization === 'cdek' ? 'map-marker--cdek' : ''} ${item.organization === 'boxberry' ? 'map-marker--market' : ''} ${item.organization === 'russianpost' ? 'map-marker--pochta' : ''}">
            <div class="map-marker__count ${allItems === itemsCount ? 'map-marker__count--all' : ''}">
              <img src="${allItems === itemsCount ? '/icons/check-white.svg' : '/icons/wait.svg'}" alt="" />
              <span>${
                itemsCount === allItems
                  ? 'Все товары'
                  : `${itemsCount} ${wordEnding(itemsCount, ['товар', 'товара', 'товаров'])} из ${allItems}`
              }</span>
            </div>
           
          </div>`,
        {
          build: function () {
            iconContentLayout.superclass.build.call(this);
          },
          clear: function () {
            iconContentLayout.superclass.clear.call(this);
          },
        }
      );

      const placemark = new (window as any).ymaps.Placemark(
        [item.latitude, item.longitude],
        {
          hintContent: '',
        },
        {
          iconLayout: iconContentLayout,
          iconShape: {
            type: 'Rectangle',
            coordinates: [
              [36, 56],
              [-18, -56],
            ],
          },
        }
      );

      placemark.events.add('click', function () {
        onPlacemarkClick?.(item);
      });

      placemarks.push(placemark);
    });
  }

  clusterer.add(placemarks);

  return clusterer;
};
